import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ContentChild,
	forwardRef,
	inject,
	Input,
	TemplateRef,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

const INPUT_CONTROL_ACCESSOR = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => ListFilterComponent),
	multi: true,
};

@Component({
	selector: "ic-list-filter",
	templateUrl: "./list-filter.component.html",
	providers: [INPUT_CONTROL_ACCESSOR],
	styleUrls: ["./list-filter.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ListFilterComponent implements ControlValueAccessor {
	private cdRef = inject(ChangeDetectorRef);

	@Input() items: any[] = [];
	@Input() key: string;
	@Input() multi = false;

	@ContentChild("itemTmpl", { static: false }) itemTemplate: TemplateRef<any>;

	values = new Set();

	private onChange = (_: unknown) => {}; // eslint-disable-line @typescript-eslint/no-empty-function
	private onTouch = () => {};

	selectItem(item: any) {
		this.setValues(this.key ? item[this.key] : item);
		const selected = Array.from(this.values);
		this.onChange(this.multi ? selected : selected[0]);
		this.onTouch();
		this.cdRef.markForCheck();
	}

	writeValue(value: any): void {
		this.values = new Set(this.multi ? value : [value]);
		this.cdRef.markForCheck();
	}

	registerOnChange(fn: (v: unknown) => void) {
		this.onChange = fn;
	}

	registerOnTouched(fn: () => void) {
		this.onTouch = fn;
	}

	isSelected(item: any) {
		return this.values.has(this.key ? item[this.key] : item);
	}

	private setValues(item: any) {
		const hasItem = this.values.has(item);

		if (!this.multi) {
			this.values = new Set(hasItem ? [] : [item]);

			return;
		}

		if (hasItem) {
			this.values.delete(item);
		} else {
			this.values.add(item);
		}
	}
}
